import * as React from "react";
import { Theme, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
	return {
		fontWeight:
			personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
	};
}

export default function MultipleSelect({
	names,
	onChangeListener,
	sel,
	label,
	single,
	noSmall,
	fullWidth,
	oneSelected,
	medium,
	grow,
}: any) {
	const theme = useTheme();
	const [personName, setPersonName] = React.useState<string[]>([]);

	React.useEffect(() => {
		if (sel) setPersonName(sel);
	}, [sel]);

	const handleChange = (event: SelectChangeEvent<typeof personName>) => {
		const {
			target: { value },
		} = event;

		if (oneSelected && ((typeof value === "string" && !value) || (typeof value !== "string" && value.length === 0)))
			return;

		const final = typeof value === "string" ? value.split(",") : value;
		let change: any = [];
		if (single) {
			if (typeof value === "string" && final.length > 0) change = [final[final.length - 1]];
			else if (final.length > 0) change = [final[final.length - 1]];
		} else {
			change = final;
		}

		setPersonName(single ? change : typeof value === "string" ? final : value);

		if (onChangeListener) {
			onChangeListener(single ? change : typeof value === "string" ? final : value);
		}
	};

	return (
		<div style={{ flexGrow: grow ? 1 : 0 }}>
			<FormControl sx={{ width: noSmall ? (medium ? 150 : 250) : fullWidth ? "100%" : "100%" }}>
				<InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
				<Select
					labelId="demo-multiple-chip-label"
					id="demo-multiple-chip"
					multiple
					value={personName}
					onChange={handleChange}
					input={<OutlinedInput id="select-multiple-chip" label={label} />}
					renderValue={selected => (
						<Box
							sx={
								single
									? { display: "flex", flexWrap: "wrap", gap: 0.5, height: 20, mt: -0.5 }
									: { display: "flex", flexWrap: "wrap", gap: 0.5, mt: -0.5 }
							}
						>
							{selected.map(value => (
								<Chip key={value} label={names.find((n: any) => n.id === value).label} />
							))}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					{names.map((name: any) => (
						<MenuItem key={name.id} value={name.id} style={getStyles(name.label, personName, theme)}>
							{name.label}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
